import {
  AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
  ENERGY_PRODUCTION_AND_MINING_LEVEL_1_THREAT_ID,
  TRANSPORTATION_AND_SERVICE_CORRIDORS_LEVEL_1_THREAT_ID,
  BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
  HUMAN_INTRUSIONS_AND_DISTURBANCE_LEVEL_1_THREAT_ID,
  NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
  INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
  POLLUTION_LEVEL_1_THREAT_ID,
  GEOLOGICAL_EVENTS_LEVEL_1_THREAT_ID,
  CLIMATE_CHANGE_AND_SEVERE_WEATHER_LEVEL_1_THREAT_ID,
  OTHER_OPTIONS_LEVEL_1_THREAT_ID,
  RESIDENTIAL_AND_COMMERCIAL_DEV_LEVEL_1_THREAT_ID
} from './levelOneThreats'

export const HOUSING_AND_URBAN_AREAS_LEVEL_2_THREAT_ID = 1
export const COMMERCIAL_AND_IN_LEVEL_2_THREAT_ID = 2
export const TOURISM_AND_RECREATIONAL_AREAS_LEVEL_2_THREAT_ID = 3
export const ANNUAL_AND_PERENNIAL_NON_TIMBER_CROPS_LEVEL_2_THREAT_ID = 4
export const WOOD_AND_PULP_PLANTATIONS_LEVEL_2_THREAT_ID = 5
export const LIVESTOCK_FARMING_AND_RANCHING_LEVEL_2_THREAT_ID = 6
export const MARINE_AND_FRESHWATER_AQUACULTURE_LEVEL_2_THREAT_ID = 7
export const OIL_AND_GAS_DRILLING_LEVEL_2_THREAT_ID = 8
export const MINING_AND_QUARRYING_LEVEL_2_THREAT_ID = 9
export const RENEWABLE_ENERGY_LEVEL_2_THREAT_ID = 10
export const ROADS_AND_RAILROADS_LEVEL_2_THREAT_ID = 11
export const UTILITY_AND_SERVICE_LINES_LEVEL_2_THREAT_ID = 12
export const SHIPPING_LANES_LEVEL_2_THREAT_ID = 13
export const FLIGHT_PATHS_LEVEL_2_THREAT_ID = 14
export const HUNTING_AND_COLLECTING_TERRESTRIAL_ANIMALS_LEVEL_2_THREAT_ID = 15
export const GATHERING_TERRESTRIAL_PLANTS_LEVEL_2_THREAT_ID = 16
export const LOGGING_AND_WOOD_HARVESTING_LEVEL_2_THREAT_ID = 17
export const FISHING_AND_HARVESTING_AQUATIC_RESOURCES_LEVEL_2_THREAT_ID = 18
export const RECREATIONAL_ACTIVITIES_LEVEL_2_THREAT_ID = 19
export const WAR_CIVIL_UNREST_AND_MILITARY_LEVEL_2_THREAT_ID = 20
export const WORK_AND_OTHER_ACTIVITIES_LEVEL_2_THREAT_ID = 21
export const FIRE_AND_FIRE_SUPPRESSION_LEVEL_2_THREAT_ID = 22
export const DAMS_AND_WATER_MANAGEMENT_LEVEL_2_THREAT_ID = 23
export const OTHER_ECOSYSTEM_MODIFICATIONS_LEVEL_2_THREAT_ID = 24
export const INVASIVE_NON_NATIVE_ALIEN_SPECIES_DISEASES_LEVEL_2_THREAT_ID = 25
export const PROBLEMATIC_NATIVE_SPECIES_DISEASES_LEVEL_2_THREAT_ID = 26
export const INTRODUCED_GENETIC_MATERIAL_LEVEL_2_THREAT_ID = 27
export const PROBLEMATIC_SPECIES_DISEASES_OF_UNKNOWN_ORIGIN_LEVEL_2_THREAT_ID = 28
export const VIRAL_PRION_INDUCED_DISEASES_LEVEL_2_THREAT_ID = 29
export const DISEASES_OF_UNKNOWN_CAUSE_LEVEL_2_THREAT_ID = 30
export const DOMESTIC_AND_URBAN_WASTE_WATER_LEVEL_2_THREAT_ID = 31
export const INDUSTRIAL_AND_MILITARY_EFFLUENTS_LEVEL_2_THREAT_ID = 32
export const AGRICULTURAL_AND_FORESTRY_EFFLUENTS_LEVEL_2_THREAT_ID = 33
export const GARBAGE_AND_SOLID_WASTE_LEVEL_2_THREAT_ID = 34
export const AIR_BORNE_POLLUTANTS_LEVEL_2_THREAT_ID = 35
export const EXCESS_ENERGY_LEVEL_2_THREAT_ID = 36
export const VOLCANOES_LEVEL_2_THREAT_ID = 37
export const EARTHQUAKES_TSUNAMI_LEVEL_2_THREAT_ID = 38
export const AVALANCHE_LANDSLIDES_LEVEL_2_THREAT_ID = 39
export const HABITAT_SHIFTING_AND_ALTERATION_LEVEL_2_THREAT_ID = 40
export const DROUGHTS_LEVEL_2_THREAT_ID = 41
export const TEMPERATURE_EXTREMES_LEVEL_2_THREAT_ID = 42
export const STORMS_AND_FLOODING_LEVEL_2_THREAT_ID = 43
export const OTHER_IMPACTS_LEVEL_2_THREAT_ID = 44
export const OTHER_THREAT_LEVEL_2_THREAT_ID = 45

export const level2Threats = [
  {
    Level1ThreatId: RESIDENTIAL_AND_COMMERCIAL_DEV_LEVEL_1_THREAT_ID,
    id: HOUSING_AND_URBAN_AREAS_LEVEL_2_THREAT_ID,
    name: 'Housing & urban areas'
  },
  {
    Level1ThreatId: RESIDENTIAL_AND_COMMERCIAL_DEV_LEVEL_1_THREAT_ID,
    id: COMMERCIAL_AND_IN_LEVEL_2_THREAT_ID,
    name: 'Commercial & industrial areas'
  },
  {
    Level1ThreatId: RESIDENTIAL_AND_COMMERCIAL_DEV_LEVEL_1_THREAT_ID,
    id: TOURISM_AND_RECREATIONAL_AREAS_LEVEL_2_THREAT_ID,
    name: 'Tourism & recreation areas'
  },
  {
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    id: ANNUAL_AND_PERENNIAL_NON_TIMBER_CROPS_LEVEL_2_THREAT_ID,
    name: 'Annual & perennial non-timber crops'
  },
  {
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    id: WOOD_AND_PULP_PLANTATIONS_LEVEL_2_THREAT_ID,
    name: 'Wood & pulp plantations'
  },
  {
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    id: LIVESTOCK_FARMING_AND_RANCHING_LEVEL_2_THREAT_ID,
    name: 'Livestock farming & ranching'
  },
  {
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    id: MARINE_AND_FRESHWATER_AQUACULTURE_LEVEL_2_THREAT_ID,
    name: 'Marine & freshwater aquaculture'
  },
  {
    Level1ThreatId: ENERGY_PRODUCTION_AND_MINING_LEVEL_1_THREAT_ID,
    id: OIL_AND_GAS_DRILLING_LEVEL_2_THREAT_ID,
    name: 'Oil & gas drilling'
  },
  {
    Level1ThreatId: ENERGY_PRODUCTION_AND_MINING_LEVEL_1_THREAT_ID,
    id: MINING_AND_QUARRYING_LEVEL_2_THREAT_ID,
    name: 'Mining & quarrying'
  },
  {
    Level1ThreatId: ENERGY_PRODUCTION_AND_MINING_LEVEL_1_THREAT_ID,
    id: RENEWABLE_ENERGY_LEVEL_2_THREAT_ID,
    name: 'Renewable energy'
  },
  {
    Level1ThreatId: TRANSPORTATION_AND_SERVICE_CORRIDORS_LEVEL_1_THREAT_ID,
    id: ROADS_AND_RAILROADS_LEVEL_2_THREAT_ID,
    name: 'Roads & railroads'
  },
  {
    Level1ThreatId: TRANSPORTATION_AND_SERVICE_CORRIDORS_LEVEL_1_THREAT_ID,
    id: UTILITY_AND_SERVICE_LINES_LEVEL_2_THREAT_ID,
    name: 'Utility & service lines'
  },
  {
    Level1ThreatId: TRANSPORTATION_AND_SERVICE_CORRIDORS_LEVEL_1_THREAT_ID,
    id: SHIPPING_LANES_LEVEL_2_THREAT_ID,
    name: 'Shipping lanes'
  },
  {
    Level1ThreatId: TRANSPORTATION_AND_SERVICE_CORRIDORS_LEVEL_1_THREAT_ID,
    id: FLIGHT_PATHS_LEVEL_2_THREAT_ID,
    name: 'Flight paths'
  },
  {
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    id: HUNTING_AND_COLLECTING_TERRESTRIAL_ANIMALS_LEVEL_2_THREAT_ID,
    name: 'Hunting & collecting terrestrial animals'
  },
  {
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    id: GATHERING_TERRESTRIAL_PLANTS_LEVEL_2_THREAT_ID,
    name: 'Gathering terrestrial plants'
  },
  {
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    id: LOGGING_AND_WOOD_HARVESTING_LEVEL_2_THREAT_ID,
    name: 'Logging & wood harvesting'
  },
  {
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    id: FISHING_AND_HARVESTING_AQUATIC_RESOURCES_LEVEL_2_THREAT_ID,
    name: 'Fishing & harvesting aquatic resources'
  },
  {
    Level1ThreatId: HUMAN_INTRUSIONS_AND_DISTURBANCE_LEVEL_1_THREAT_ID,
    id: RECREATIONAL_ACTIVITIES_LEVEL_2_THREAT_ID,
    name: 'Recreational activities'
  },
  {
    Level1ThreatId: HUMAN_INTRUSIONS_AND_DISTURBANCE_LEVEL_1_THREAT_ID,
    id: WAR_CIVIL_UNREST_AND_MILITARY_LEVEL_2_THREAT_ID,
    name: 'War, civil unrest & military exercises'
  },
  {
    Level1ThreatId: HUMAN_INTRUSIONS_AND_DISTURBANCE_LEVEL_1_THREAT_ID,
    id: WORK_AND_OTHER_ACTIVITIES_LEVEL_2_THREAT_ID,
    name: 'Work & other activities'
  },
  {
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    id: FIRE_AND_FIRE_SUPPRESSION_LEVEL_2_THREAT_ID,
    name: 'Fire & fire suppression'
  },
  {
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    id: DAMS_AND_WATER_MANAGEMENT_LEVEL_2_THREAT_ID,
    name: 'Dams & water management/use'
  },
  {
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    id: OTHER_ECOSYSTEM_MODIFICATIONS_LEVEL_2_THREAT_ID,
    name: 'Other ecosystem modifications'
  },
  {
    Level1ThreatId: INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
    id: INVASIVE_NON_NATIVE_ALIEN_SPECIES_DISEASES_LEVEL_2_THREAT_ID,
    name: 'Invasive non-native/alien species/diseases'
  },
  {
    Level1ThreatId: INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
    id: PROBLEMATIC_NATIVE_SPECIES_DISEASES_LEVEL_2_THREAT_ID,
    name: 'Problematic native species/diseases'
  },
  {
    Level1ThreatId: INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
    id: INTRODUCED_GENETIC_MATERIAL_LEVEL_2_THREAT_ID,
    name: 'Introduced genetic material'
  },
  {
    Level1ThreatId: INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
    id: PROBLEMATIC_SPECIES_DISEASES_OF_UNKNOWN_ORIGIN_LEVEL_2_THREAT_ID,
    name: 'Problematic species/diseases of unknown origin'
  },
  {
    Level1ThreatId: INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
    id: VIRAL_PRION_INDUCED_DISEASES_LEVEL_2_THREAT_ID,
    name: 'Viral/prion-induced diseases'
  },
  {
    Level1ThreatId: INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
    id: DISEASES_OF_UNKNOWN_CAUSE_LEVEL_2_THREAT_ID,
    name: 'Diseases of unknown cause'
  },
  {
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    id: DOMESTIC_AND_URBAN_WASTE_WATER_LEVEL_2_THREAT_ID,
    name: 'Domestic & urban waste water'
  },
  {
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    id: INDUSTRIAL_AND_MILITARY_EFFLUENTS_LEVEL_2_THREAT_ID,
    name: 'Industrial & military effluents'
  },
  {
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    id: AGRICULTURAL_AND_FORESTRY_EFFLUENTS_LEVEL_2_THREAT_ID,
    name: 'Agricultural & forestry effluents'
  },
  {
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    id: GARBAGE_AND_SOLID_WASTE_LEVEL_2_THREAT_ID,
    name: 'Garbage & solid waste'
  },
  {
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    id: AIR_BORNE_POLLUTANTS_LEVEL_2_THREAT_ID,
    name: 'Air-borne pollutants'
  },
  {
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    id: EXCESS_ENERGY_LEVEL_2_THREAT_ID,
    name: 'Excess energy'
  },
  {
    Level1ThreatId: GEOLOGICAL_EVENTS_LEVEL_1_THREAT_ID,
    id: VOLCANOES_LEVEL_2_THREAT_ID,
    name: 'Volcanoes'
  },
  {
    Level1ThreatId: GEOLOGICAL_EVENTS_LEVEL_1_THREAT_ID,
    id: EARTHQUAKES_TSUNAMI_LEVEL_2_THREAT_ID,
    name: 'Earthquakes/tsunamis'
  },
  {
    Level1ThreatId: GEOLOGICAL_EVENTS_LEVEL_1_THREAT_ID,
    id: AVALANCHE_LANDSLIDES_LEVEL_2_THREAT_ID,
    name: 'Avalanches/landslides'
  },
  {
    Level1ThreatId: CLIMATE_CHANGE_AND_SEVERE_WEATHER_LEVEL_1_THREAT_ID,
    id: HABITAT_SHIFTING_AND_ALTERATION_LEVEL_2_THREAT_ID,
    name: 'Habitat shifting & alteration'
  },
  {
    Level1ThreatId: CLIMATE_CHANGE_AND_SEVERE_WEATHER_LEVEL_1_THREAT_ID,
    id: DROUGHTS_LEVEL_2_THREAT_ID,
    name: 'Droughts'
  },
  {
    Level1ThreatId: CLIMATE_CHANGE_AND_SEVERE_WEATHER_LEVEL_1_THREAT_ID,
    id: TEMPERATURE_EXTREMES_LEVEL_2_THREAT_ID,
    name: 'Temperature extremes'
  },
  {
    Level1ThreatId: CLIMATE_CHANGE_AND_SEVERE_WEATHER_LEVEL_1_THREAT_ID,
    id: STORMS_AND_FLOODING_LEVEL_2_THREAT_ID,
    name: 'Storms & flooding'
  },
  {
    Level1ThreatId: CLIMATE_CHANGE_AND_SEVERE_WEATHER_LEVEL_1_THREAT_ID,
    id: OTHER_IMPACTS_LEVEL_2_THREAT_ID,
    name: 'Other impacts'
  },
  {
    Level1ThreatId: OTHER_OPTIONS_LEVEL_1_THREAT_ID,
    id: OTHER_THREAT_LEVEL_2_THREAT_ID,
    name: 'Other threat'
  }
]
